<template>
<div style="width: 100%; height: 100%; overflow-y: auto; overflow-x: hidden;">
    <div style="display: flex; flex-direction: column; padding: 30px; gap: 10px; width: 100%; padding-top: 20px;">
        <div style="margin-bottom: 10px;"><el-tag color="rgb(215,222,231)" effect="dark" class="left-tag" size="large" style="width: fit-content; color: black; font-weight: bold;">
            Introduction to the design space
        </el-tag></div>
        <!-- WHY -->
        <div><el-tag color="rgb(11,175,169)" effect="dark" class="left-tag" size="large" style="width: fit-content;">
            <strong>WHY</strong> apply visual metaphor?
        </el-tag></div>
        <div v-for="name in whyList" :key="name" style="display: flex; gap: 20px; align-items: start; margin: 20px;">
            <img 
                :src="require(`../assets/SVG/${eng2chn[name]}.svg`)"
                style="width: 120px; height: 120px; margin-right: 10px;" />
            <div style="display: flex; flex-direction: column; align-items: start; width: 300px;">
                <el-tag class="why-tag" size="large" style="font-size: 16px;"> WHY: {{ translate(name)}} </el-tag>
                <span style="font-size: 16px; margin-top: 10px;"> {{ intro[name].description }} </span>
            </div>
            <div style="flex: 1; overflow-x: auto; display: flex; gap: 0; width: 100%; margin-right: 10px;">
                <div v-for="example in intro[name].examples" :key="example.name" style="display: flex; flex-direction: column; align-items: start; gap: 10px; width: 200px; margin-right: 20px;">
                    <el-tag class="why-tag" size="large" style="font-size: 16px;"> EXAMPLE: {{ example.name }} </el-tag>
                    <el-image
                        :src="imageUrl(example.name, 1)"
                        :preview-src-list="[imageUrl(example.name)]"
                        style="height: 150px; width: 200px"
                        fit="cover"
                    >
                        <div slot="placeholder" class="image-slot">
                        <i class="el-icon-loading"></i>
                        Loading<span class="dot">...</span>
                        </div>
                        <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                    <span style="font-size: 16px;"> {{ example.description }} </span>
                </div>
            </div>
        </div>
        <!-- WHAT -->
        <div><el-tag color="rgb(118,118,251)" effect="dark" class="left-tag" size="large" style="width: fit-content;">
            <strong>WHAT</strong> data to show?
        </el-tag></div>
        <div v-for="name in whatList" :key="name" style="display: flex; gap: 20px; align-items: start; margin: 20px;">
            <img 
                :src="require(`../assets/SVG/${eng2chn[name]}.svg`)"
                style="width: 120px; height: 120px; margin-right: 10px;" />
            <div style="display: flex; flex-direction: column; align-items: start; width: 300px;">
                <el-tag class="what-tag" size="large" style="font-size: 16px;"> WHAT: {{ translate(name)}} </el-tag>
                <span style="font-size: 16px; margin-top: 10px;"> {{ intro[name].description }} </span>
            </div>
            <div style="flex: 1; overflow-x: auto; display: flex; gap: 0; width: 100%; margin-right: 10px;">
                <div v-for="example in intro[name].examples" :key="example.name" style="display: flex; flex-direction: column; align-items: start; gap: 10px; width: 200px; margin-right: 20px;">
                    <el-tag class="what-tag" size="large" style="font-size: 16px;"> EXAMPLE: {{ example.name }} </el-tag>
                    <el-image
                        :src="imageUrl(example.name, 1)"
                        :preview-src-list="[imageUrl(example.name)]"
                        style="height: 150px; width: 200px"
                        fit="cover"
                    >
                        <div slot="placeholder" class="image-slot">
                        <i class="el-icon-loading"></i>
                        Loading<span class="dot">...</span>
                        </div>
                        <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                    <span style="font-size: 16px;"> {{ example.description }} </span>
                </div>
            </div>
        </div>
        <!-- HOW -->
        <div style="display: flex; gap: 20px; align-items: center;">
            <el-tag color="rgb(96,140,244)" effect="dark" class="left-tag" size="large">
            <strong>HOW</strong> to establish conceptually?
            </el-tag>
            <span style="font-size: 17px">
            Establish visual metaphors with mappings by:
            </span>
        </div>
        <div><el-tag effect="dark" class="how-tag" size="large" style="width: fit-content;">
            Denotation Mappings
        </el-tag></div>
        <div v-for="name in howList1" :key="name" style="display: flex; gap: 20px; align-items: start; margin: 20px;">
            <img 
                :src="require(`../assets/SVG/${eng2chn[name]}.svg`)"
                style="width: 120px; height: 120px; margin-right: 10px;" />
            <div style="display: flex; flex-direction: column; align-items: start; width: 300px;">
                <el-tag class="how-tag" size="large" style="font-size: 16px;"> HOW: {{ translate(name)}} </el-tag>
                <span style="font-size: 16px; margin-top: 10px;"> {{ intro[name].description }} </span>
            </div>
            <div style="flex: 1; overflow-x: auto; display: flex; gap: 0; width: 100%; margin-right: 10px;">
                <div v-for="example in intro[name].examples" :key="example.name" style="display: flex; flex-direction: column; align-items: start; gap: 10px; width: 200px; margin-right: 20px;">
                    <el-tag class="how-tag" size="large" style="font-size: 16px;"> EXAMPLE: {{ example.name }} </el-tag>
                    <el-image
                        :src="imageUrl(example.name, 1)"
                        :preview-src-list="[imageUrl(example.name)]"
                        style="height: 150px; width: 200px"
                        fit="cover"
                    >
                        <div slot="placeholder" class="image-slot">
                        <i class="el-icon-loading"></i>
                        Loading<span class="dot">...</span>
                        </div>
                        <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                    <span style="font-size: 16px;"> {{ example.description }} </span>
                </div>
            </div>
        </div>
        <div><el-tag effect="dark" class="how-tag" size="large" style="width: fit-content;">
            Connotation Mappings
        </el-tag></div>
        <div v-for="name in howList2" :key="name" style="display: flex; gap: 20px; align-items: start; margin: 20px;">
            <img 
                :src="require(`../assets/SVG/${eng2chn[name]}.svg`)"
                style="width: 120px; height: 120px; margin-right: 10px;" />
            <div style="display: flex; flex-direction: column; align-items: start; width: 300px;">
                <el-tag class="how-tag" size="large" style="font-size: 16px;"> HOW: {{ translate(name)}} </el-tag>
                <span style="font-size: 16px; margin-top: 10px;"> {{ intro[name].description }} </span>
            </div>
            <div style="flex: 1; overflow-x: auto; display: flex; gap: 0; width: 100%; margin-right: 10px;">
                <div v-for="example in intro[name].examples" :key="example.name" style="display: flex; flex-direction: column; align-items: start; gap: 10px; width: 200px; margin-right: 20px;">
                    <el-tag class="how-tag" size="large" style="font-size: 16px;"> EXAMPLE: {{ example.name }} </el-tag>
                    <el-image
                        :src="imageUrl(example.name, 1)"
                        :preview-src-list="[imageUrl(example.name)]"
                        style="height: 150px; width: 200px"
                        fit="cover"
                    >
                        <div slot="placeholder" class="image-slot">
                        <i class="el-icon-loading"></i>
                        Loading<span class="dot">...</span>
                        </div>
                        <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                        </div>
                    </el-image>
                    <span style="font-size: 16px;"> {{ example.description }} </span>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { chn2eng, eng2chn, translate2chn, introduction } from '../utils/defs.js';
export default {
    name: 'Intro',
    components: {
    },
    props: {
    },
    watch: {
    },
    data() {
      return {
        chn2eng: chn2eng,
        eng2chn: eng2chn,
        intro: introduction,
        whatList: ['Data Items', 'Data Attributes', 'Data Facts', 'Data Relationships'],
        whyList: ['Illustrate Topics', 'Explain Data', 'Evoke Emotion'],
        howList1: ['Appearance', 'Silhouette', 'Structure'],
        howList2: ['Status', 'Function', 'Process', 'Orientation', 'Color'],
      }
    },
    computed: {
    },
    methods: {
      translate(name, eng=1) {
        if (eng) return translate2chn(name);
        return translate2chn(this.chn2eng[name]);
      },
      imageUrl(name, thumb=0) {
        return '/api/image?name=' + name + (thumb ? '&thumb=1' : '');
      },
    }
}
</script>
